import { render, staticRenderFns } from "./DeviceDetailScreenshot.vue?vue&type=template&id=83278aec&"
import script from "./DeviceDetailScreenshot.vue?vue&type=script&lang=js&"
export * from "./DeviceDetailScreenshot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports